<template>
  <div :id="layerId" :gk-common-layer="componentName" :class="layerClass" v-if="isVisible">
    <transition :name="transition">
      <div class="layer" v-if="isLayerShow"></div>
    </transition>
    <div class="layer-component">
      <component :is="component"></component>
    </div>
  </div>
</template>
 
<script>
import VueTypes from 'vue-types'
import utils from '../../utils'

export default {
  name: 'gk-common-layer',
  components: {
  },
  props: {
    componentName: VueTypes.string.def(''),
    id: VueTypes.string.def(''),
    layer: VueTypes.bool.def(true),
    transition: VueTypes.string.def('fade')
  },
  data () {
    return {
      isVisible: false,
      isLayerShow: false,
      component: null
    }
  },
  computed: {
    layerId () {
      return `gk-common-layer${this.id}`
    },
    layerClass () {
      return [
        `gk-common-layer-${this.componentName}`
      ]
    }
  },
  watch: {
    isLayerShow (show) {
      show ? utils.fixedBody.open() : utils.fixedBody.close()
    }
  },
  created () {
  },
  beforeDestroy () {
    document.body.removeChild(this.$el)
  },
  methods: {
    showLayer () {
      if (this.layer) {
        this.isLayerShow = true
      }
      return this
    },
    hideLayer () {
      this.isLayerShow = false
      return this
    },
    installComponent (component) {
      this.component = component
    },
    uninstallComponent () {
      this.component = null
    },
    /**
     * 显示弹框组件
     */
    show () {
      this.isVisible = true
      return this
    },
    hide () {
      this.isVisible = false
      return this
    }
  }
}
</script>
<style lang="scss" scoped>
.layer {
  position: fixed; z-index: 90000; top: 0; left: 0; right: 0; bottom: 0;
  background: rgba($color: #000000, $alpha: 0.6);
  overflow: auto;
}

.layer-component {
  position: fixed; z-index: 90001; top: 0; left: 0; right: 0; bottom: 0;
  pointer-events: none;
}
</style>
 